import React, { memo, Fragment, useEffect } from "react";
import { useRowSelect, useTable } from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _, { isArray } from "lodash";
import classNames from "classnames";
import { format } from "date-fns";
import { faAngleUp, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import "react-toastify/dist/ReactToastify.css";
import numeral from "numeral";
import Skeleton from "react-loading-skeleton";
import { useParams } from "react-router-dom";
import { useMemo } from "react";
import { useState } from "react";
import { Auth } from "aws-amplify";
import { EmitterStatus } from "../../../event";
import { getCurrentLocalDateTime } from "../../../utils/getLocalDateTime";
import Swal from "sweetalert2";
import { getLastDemandFee } from "components/Leasing/utils/leasing.u";
import IndeterminateCheckbox from "../components/leasing.c.indeterminateCheckbox";
import API from "../api/api.main";
import axios from "axios";
import { faker } from "@faker-js/faker";
import { generateCitizenId } from "./leasing.f.createtf";
import { checkRole } from "../../../utils/role";
import { useSelector } from "react-redux";

const Row = ({ row, i, value, env }) => {
  const params = useParams();

  const onClickRoute = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (env === "production") {
      return window.open(
        `/leasingInfo/${row.original.loan_id}?category=${row.original.category}&env=production`,
        "_blank"
      );
    }
    window.open(
      `/leasingSandboxInfo/${row.original.loan_id}?category=${row.original.category}&env=sandbox`,
      "_blank"
    );
  };

  return (
    <Fragment>
      <tr
        {...row.getRowProps()}
        onClick={onClickRoute}
        className={classNames(
          "hover:bg-blueGray-200  transition-all duration-300 relative",
          {
            "bg-white": i % 2 === 0,
            "bg-gray-50": i % 2 !== 0,
            "cursor-pointer": row.original?.isCopy === "false",
          }
        )}
      >
        {row.cells.map((cell, index) => {
          return (
            <td
              key={index}
              className={classNames("p-4 text-gray-700 text-xs text-center", {
                " select-none": row.original?.isCopying === "true",
              })}
              {...cell.getCellProps()}
            >
              {row.original?.isCopying === "true" && index === 0 && (
                <div className="w-full h-full absolute top-1/2 flex items-center opacity-70 justify-center left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center  bg-black">
                  <div className=" text-gray-400 text-sm">กำลังดำเนินการ</div>
                </div>
              )}
              {cell.render("Cell")}
            </td>
          );
        })}
      </tr>
    </Fragment>
  );
};

function FootageTableMain({
  loading,
  leasings = [],
  setLeasings,
  category,
  refetch,
  date = new Date(),
  isChange,
  env = "sandbox",
  setSelectedRows,
  selectedRows = [],
}) {
  const [loadingDelete, setLoadingDelete] = useState(-1);
  const [loadingCopy, setLoadingCopy] = useState(-1);
  const [loadingApprove, setLoadingApprove] = useState(-1);
  const { user } = useSelector((state) => state?.initializeApp);

  const convertPath = env === "sandbox" ? "Sandbox" : "";

  const onClickApproveVisitFee = (row, setCanAdd) => async (e) => {
    try {
      e?.stopPropagation();
      e?.preventDefault();
      setLoadingApprove(row.index);

      const dataVisitFee = await API.get(
        "MoneyHubAdmin",
        `/leasing/interest?name=VISIT_FEE`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );

      const resultAlert = await Swal.fire({
        title: "คุณยืนยันที่จะอนุมัติขั้นต้นคำขอนี้หรือไม่ ?",
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        input: "text",
        inputAttributes: {
          autocapitalize: "off",
        },
        inputValue: dataVisitFee.VISIT_FEE,
        inputLabel: "ค่าลงพื้นที่",
        preConfirm: async (fee_amount) => {
          const data = await API.put(
            "MoneyHubAdmin",
            `/leasing/loan${convertPath}/addFee/${row.original.loan_id}`,
            {
              body: {
                fee_amount: fee_amount,
                fee_remark: "-",
                fee_type: "visit_fee",
                paid_date: getCurrentLocalDateTime(new Date(date)).isoDateTime,
              },
              headers: {
                Authorization: `Bearer ${(await Auth.currentSession())
                  .getIdToken()
                  .getJwtToken()}`,
              },
            }
          );
          if (data.type === "E") {
            await EmitterStatus("ERROR", { text: data.message });
          }
        },
      });
      if (!resultAlert.isConfirmed) return;
      await EmitterStatus("SUCCESS");
      await refetch();
      setCanAdd(false);
    } catch (error) {
      console.log("approve error", error);
      await EmitterStatus("ERROR");
    } finally {
      setLoadingApprove(-1);
    }
  };

  const onClickApproveDemandFee = (row, setCanAdd) => async (e) => {
    try {
      e?.stopPropagation();
      e?.preventDefault();
      setLoadingApprove(row.index);

      const dataDemandFee = await API.get(
        "MoneyHubAdmin",
        `/leasing/interest?name=DEMAND_FEE_NTF_ONE`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );

      const loanId = await API.get(
        "MoneyHubAdmin",
        `/leasing/loan${convertPath}/${row?.original?.loan_id}?paid_date=${
          getCurrentLocalDateTime(new Date(date)).dateTime
        }`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );

      const defaultDemandFee = loanId?.leasing?.lastDemandFee;

      const resultAlert = await Swal.fire({
        title: "คุณยืนยันที่จะอนุมัติขั้นต้นคำขอนี้หรือไม่ ?",
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        input: "text",
        inputAttributes: {
          autocapitalize: "off",
          disabled: true,
        },
        customClass: {
          input: "bg-gray-300 cursor-not-allowed",
        },
        inputValue: defaultDemandFee || 0,
        inputLabel: "ค่าท่วงถาม",
        preConfirm: async (fee_amount) => {
          const data = await API.put(
            "MoneyHubAdmin",
            `/leasing/loan${convertPath}/addFee/${row.original.loan_id}`,
            {
              body: {
                fee_amount: fee_amount,
                fee_remark: "-",
                fee_type: "demand_fee",
                paid_date: getCurrentLocalDateTime(new Date(date)).isoDateTime,
              },
              headers: {
                Authorization: `Bearer ${(await Auth.currentSession())
                  .getIdToken()
                  .getJwtToken()}`,
              },
            }
          );
          if (data.type === "E") {
            await EmitterStatus("ERROR", { text: data.message });
          }
        },
      });
      if (!resultAlert.isConfirmed) return;
      await EmitterStatus("SUCCESS");
      await refetch();
      setCanAdd(false);
    } catch (error) {
      console.log("approve error", error);
      await EmitterStatus("ERROR");
    } finally {
      setLoadingApprove(-1);
    }
  };

  const onClickCopy = (row) => async (e) => {
    try {
      e?.stopPropagation();
      e?.preventDefault();
      setLoadingCopy(row.index);

      if (env !== "production") {
        const name = faker.name.firstName();
        const lastname = faker.name.lastName();

        await axios.post(
          "https://rc5zblnalj4ogfpzzjpr4vgwwy0bczmk.lambda-url.ap-southeast-1.on.aws",
          {
            isCopy: "true",
            loan_id: row.original.loan_id,
            name,
            lastname,
            citizenid: `${generateCitizenId()}`,
          }
        );
      } else {
        await axios.post(
          "https://j3glljytyvmcsgpo2cugffk3by0vivjw.lambda-url.ap-southeast-1.on.aws",
          {
            env: "copy_to_sandbox",
            params: {
              loan_id: row?.original?.loan_id,
            },
            body: {
              name: row?.original?.name,
              lastname: row?.original?.lastname,
              citizenid: `${row?.original?.citizenid}`,
            },
          }
        );
      }

      // const data = await API.post(
      //   "MoneyHubAdmin",
      //   `/leasing/loanSandbox/copy/${row.original.loan_id}`,
      //   {
      //     body: {
      //       isCopy: "true",
      //     },
      //     headers: {
      //       Authorization: `Bearer ${(await Auth.currentSession())
      //         .getIdToken()
      //         .getJwtToken()}`,
      //     },
      //   }
      // );
      // await API.post("MoneyHubAdmin", `/leasing/loanSandbox/interfaceCreate`, {
      //   body: {
      //     loan_id: data.loan_id,
      //   },
      //   headers: {
      //     Authorization: `Bearer ${(await Auth.currentSession())
      //       .getIdToken()
      //       .getJwtToken()}`,
      //   },
      // });
      await EmitterStatus("SUCCESS", {
        text: "กำลังสร้างข้อมูลใหม่ กรุณารอสักครู่",
      });
      await refetch();
    } catch (error) {
      console.log("delete error", error);
      await EmitterStatus("ERROR");
    } finally {
      setLoadingCopy(-1);
    }
  };

  const onClickDelete = (row) => async (e) => {
    try {
      e?.stopPropagation();
      e?.preventDefault();
      setLoadingDelete(row.index);

      const pathUrl =
        env === "production" ? "/leasing" : "/leasing/loanSandbox";
      const pathLoanUrl =
        env === "production" ? "/leasing/loan" : "/leasing/loanSandbox";

      await API.del("MoneyHubAdmin", `${pathLoanUrl}/${row.original.loan_id}`, {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      await API.del(
        "MoneyHubAdmin",
        `${pathUrl}/postOtherRevenue/${row.original.loan_id}`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      await API.del(
        "MoneyHubAdmin",
        `${pathUrl}/arClear/${row.original.loan_id}`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      await API.del(
        "MoneyHubAdmin",
        `${pathUrl}/interfaceCreate/${row.original.loan_id}`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      await API.del(
        "MoneyHubAdmin",
        `${pathUrl}/contractCancel/${row.original.loan_id}`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      await API.del(
        "MoneyHubAdmin",
        `${pathUrl}/seizeVehicle/${row.original.loan_id}`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      await API.del(
        "MoneyHubAdmin",
        `${pathUrl}/transferVehicle/${row.original.loan_id}`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      await API.del(
        "MoneyHubAdmin",
        `${pathUrl}/accruedInterest/${row?.original?.loan_id}`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      await EmitterStatus("SUCCESS");
      await refetch();
    } catch (error) {
      console.log("delete error", error);
      await EmitterStatus("ERROR");
    } finally {
      setLoadingDelete(-1);
    }
  };

  const columnFilter = (column) => {
    if (category === "NTF") {
      return !["visit_fee_and_demand_fee"].includes(column?.accessor);
    }

    // if (env === "production") {
    //   return !["settings"].includes(column?.accessor);
    // }

    return column;
  };

  const columns = useMemo(() => {
    let localColumn = [
      {
        Header: "Job No.",
        accessor: "loan_id",
      },
      {
        Header: "ชื่อ",
        accessor: "fullname",
        Cell: ({ row }) => {
          if (row?.original?.copyFrom !== "-") {
            return (
              <div>
                <div>
                  {row?.original?.fullname}_{row.original?.copyFrom}
                </div>
              </div>
            );
          }

          return <div>{row?.original?.fullname}</div>;
        },
      },
      {
        Header: "จำนวนงวด",
        accessor: "period",
      },
      {
        Header: "ประเภทสินเชื่อ",
        accessor: "purpose",
      },
      {
        Header: "ประเภทรถ",
        accessor: "type",
      },
      {
        Header: "เงินทุน",
        accessor: "initCapital",
        Cell: ({ row }) => {
          return <div>{numeral(row.values.initCapital).format("0,0")}</div>;
        },
      },
      {
        Header: "ดอกเบี้ย",
        accessor: "interest",
        Cell: ({ row }) => {
          return <div>{row.values.interest} %</div>;
        },
      },
      {
        Header: "ผ่อนต่อเดือน",
        accessor: "payPerMonth",
        Cell: ({ row }) => {
          return <div>{numeral(row.values.payPerMonth).format("0,0")}</div>;
        },
      },
      {
        Header: "เบอร์โทร",
        accessor: "phone_number",
      },
      {
        Header: "วันที่สร้าง",
        accessor: "createdAt",
        Cell: ({ row }) => {
          return (
            <div>
              {format(new Date(row.values.createdAt), "dd-MM-yyyy HH:mm")}
            </div>
          );
        },
      },
      {
        Header: "วันที่แก้ไข",
        accessor: "updatedAt",
        Cell: ({ row }) => {
          if (row.values?.updatedAt === "-") return <div>-</div>;
          return (
            <div>
              {format(new Date(row.values.updatedAt), "dd-MM-yyyy HH:mm")}
            </div>
          );
        },
      },
      {
        Header: "สถานะ",
        accessor: "loan_status",
        Cell: ({ row }) => {
          const { loan_status } = row.values;
          return (
            <div
              className={classNames({
                "text-green-500": loan_status === "ACTIVE",
                "text-red-500": ["LATE", "FAIL", "CANCEL"].includes(
                  loan_status
                ),
                "text-yellow-500": loan_status === "PENDING",
                "text-purple-500": loan_status === "REFINANCE",
                "text-green-600": loan_status === "DONE",
              })}
            >
              {loan_status}
            </div>
          );
        },
      },
      {
        Header: "ค่าธรรมเนียม",
        accessor: "visit_fee_and_demand_fee",
        Cell: ({ row }) => {
          const original = row.original;

          const [loading, setLoading] = useState(true);
          const [error, setError] = useState(null);
          const [canAddVisitFee, setCanAddVisitFee] = useState(false);
          const [canAddDemandFee, setCanAddDemandFee] = useState(false);

          useEffect(() => {
            if (original.category === "TF") {
              fetchDetechVisitFee();
              fetchDetechDemandFee();
            }
          }, []);

          const fetchDetechVisitFee = async () => {
            try {
              if (loadingDelete >= 0) return;

              setLoading(true);
              const data = await API.get(
                "MoneyHubAdmin",
                `/leasing/loan${convertPath}/detectVisitFee/${
                  row.original.loan_id
                }?paid_date=${getCurrentLocalDateTime(date).fullDate}`,
                {
                  headers: {
                    Authorization: `Bearer ${(await Auth.currentSession())
                      .getIdToken()
                      .getJwtToken()}`,
                  },
                }
              );
              setCanAddVisitFee(data?.canAddVisitFee);
            } catch (error) {
              setError(error);
            } finally {
              setLoading(false);
            }
          };

          const fetchDetechDemandFee = async () => {
            try {
              if (loadingDelete >= 0) return;

              setLoading(true);
              const data = await API.get(
                "MoneyHubAdmin",
                `/leasing/loan${convertPath}/detectDemandFee/${
                  row.original.loan_id
                }?paid_date=${getCurrentLocalDateTime(date).fullDate}`,
                {
                  headers: {
                    Authorization: `Bearer ${(await Auth.currentSession())
                      .getIdToken()
                      .getJwtToken()}`,
                  },
                }
              );
              setCanAddDemandFee(data?.canAddDemandFee);
            } catch (error) {
              setError(error);
            } finally {
              setLoading(false);
            }
          };

          const getDisplayText = (text) => {
            if (loading) {
              return "กำลังตรวจสอบ";
            }

            if (loadingApprove === row.index) {
              return "กำลังบันทึก...";
            }

            return text;
          };

          const getDisabled = (canAdd) => {
            if (loading) {
              return true;
            }

            if (loadingApprove === row.index) {
              return true;
            }

            if (canAdd) {
              return false;
            }
            return true;
          };

          if (original.category === "NTF") {
            return null;
          }

          return (
            <div className="flex space-x-1 text-xs w-40 items-center justify-center mx-auto">
              <button
                disabled={getDisabled(canAddVisitFee)}
                onClick={onClickApproveVisitFee(row, setCanAddVisitFee)}
                className={classNames(
                  "px-2 py-1 rounded-sm shadow-sm text-white",
                  {
                    " bg-green-500 cursor-pointer":
                      !getDisabled(canAddVisitFee),
                    " bg-gray-300 cursor-not-allowed":
                      getDisabled(canAddVisitFee),
                  }
                )}
              >
                {getDisplayText("ลงค่าพื้นที่")}
              </button>
              <button
                disabled={getDisabled(canAddDemandFee)}
                onClick={onClickApproveDemandFee(row, setCanAddDemandFee)}
                className={classNames(
                  "px-2 py-1 rounded-sm shadow-sm text-white",
                  {
                    " bg-green-500 cursor-pointer":
                      !getDisabled(canAddDemandFee),
                    " bg-gray-300 cursor-not-allowed":
                      getDisabled(canAddDemandFee),
                  }
                )}
              >
                {getDisplayText("ลงค่าทวงถาม")}
              </button>
            </div>
          );
        },
      },
      {
        Header: "อื่นๆ",
        accessor: "settings",
        Cell: ({ row }) => {
          // if (checkRole(user?.groups, ["SuperAdmin"])) {
          //   return (
          //     <div className="flex space-x-1">
          //       {env !== "production" && (
          // <button
          //   disabled={loadingCopy === row.index}
          //   onClick={onClickCopy(row)}
          //   className={classNames(
          //     "px-3 py-2 rounded-sm shadow-sm text-white",
          //     {
          //       " bg-green-500 cursor-pointer":
          //         loadingCopy !== row?.index,
          //       " bg-gray-300 cursor-not-allowed":
          //         loadingCopy === row?.index,
          //     }
          //   )}
          // >
          //           {loadingCopy === row?.index ? "กำลังบันทึก..." : "copy"}
          //         </button>
          //       )}

          //       <button
          //         disabled={loadingDelete === row.index}
          //         onClick={onClickDelete(row)}
          //         className={classNames(
          //           "px-3 py-2 rounded-sm shadow-sm text-white",
          //           {
          //             " bg-red-500 cursor-pointer": loadingDelete !== row.index,
          //             " bg-gray-300 cursor-not-allowed":
          //               loadingDelete === row.index,
          //           }
          //         )}
          //       >
          //         {loadingDelete === row.index ? "กำลังบันทึก..." : "ลบ"}
          //       </button>
          //     </div>
          //   );
          // }

          return (
            <div className="flex space-x-2">
              <button
                disabled={loadingCopy === row.index}
                onClick={onClickCopy(row)}
                className={classNames(
                  "px-3 py-2 rounded-sm shadow-sm text-white",
                  {
                    " bg-green-500 cursor-pointer": loadingCopy !== row?.index,
                    " bg-gray-300 cursor-not-allowed":
                      loadingCopy === row?.index,
                  }
                )}
              >
                clone
              </button>
              {row?.original?.phone_number === "0875003282" && (
                <button
                  disabled={loadingDelete === row.index}
                  onClick={onClickDelete(row)}
                  className={classNames(
                    "px-3 py-2 rounded-sm shadow-sm text-white",
                    {
                      " bg-red-500 cursor-pointer": loadingDelete !== row.index,
                      " bg-gray-300 cursor-not-allowed":
                        loadingDelete === row.index,
                    }
                  )}
                >
                  {loadingDelete === row.index ? "กำลังบันทึก..." : "ลบ"}
                </button>
              )}

              {/* <button
                disabled={loadingDelete === row.index}
                onClick={onClickDelete(row)}
                className={classNames(
                  "px-3 py-2 rounded-sm shadow-sm text-white",
                  {
                    " bg-red-500 cursor-pointer": loadingDelete !== row.index,
                    " bg-gray-300 cursor-not-allowed":
                      loadingDelete === row.index,
                  }
                )}
              >
                {loadingDelete === row.index ? "กำลังบันทึก..." : "ลบ"}
              </button> */}
            </div>
          );
        },
      },
    ];

    localColumn = localColumn.filter(columnFilter);

    return localColumn;
  }, [
    leasings,
    category,
    loading,
    loadingDelete,
    loadingCopy,
    loadingApprove,
    isChange,
  ]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
  } = useTable({ columns, data: leasings }, useRowSelect, (hooks) => {
    hooks.visibleColumns.push((columns) => [
      {
        id: "selection",
        Header: ({
          flatRows,
          getToggleAllRowsSelectedProps,
          toggleRowSelected,
          rows,
          ...props
        }) => {
          const onChangeAll = (e) => {
            flatRows.forEach((row) => {
              toggleRowSelected(row.id, e.target.checked);
            });
          };

          return (
            <div>
              <IndeterminateCheckbox
                onChange={onChangeAll}
                flatRows={flatRows}
                id="ALL"
              />
            </div>
          );
        },
        Cell: ({
          row,
          toggleRowSelected,
          selectedFlatRows,
          flatRows,
          ...props
        }) => {
          return (
            <div className="pointer-events-auto cursor-pointer">
              <IndeterminateCheckbox
                selectedFlatRows={selectedFlatRows}
                flatRows={flatRows}
                onClick={(e) => e.stopPropagation()}
                {...row.getToggleRowSelectedProps()}
              />
            </div>
          );
        },
      },
      ...columns,
    ]);
  });

  useEffect(() => {
    if (setSelectedRows) {
      setSelectedRows(selectedFlatRows);
    }
  }, [selectedFlatRows]);

  if (loading) return <Skeleton height={28} count={10} />;

  return (
    <table {...getTableProps()} className="w-full whitespace-no-wrap">
      <thead className=" text-xs font-semibold tracking-wide text-gray-500 border-blue-400  border-b dark:border-gray-700 bg-white dark:text-gray-400 dark:bg-gray-800">
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column, i) => (
              <th
                {...column.getHeaderProps()}
                className={classNames(
                  "px-4 py-3 text-blue-500 text-center text-xs",
                  {
                    "rounded-tl": i === 0,
                    "rounded-tr": i === headerGroup.headers.length - 1,
                  }
                )}
              >
                {column.render("Header")}
                <span>
                  {" "}
                  {column.isSorted ? (
                    column.isSortedDesc ? (
                      <FontAwesomeIcon icon={faAngleDown} />
                    ) : (
                      <FontAwesomeIcon icon={faAngleUp} />
                    )
                  ) : (
                    ""
                  )}
                </span>
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody
        className="bg-white  dark:divide-gray-700 dark:bg-gray-800 text-gray-700 dark:text-gray-400"
        {...getTableBodyProps()}
      >
        {rows.map((row, i) => {
          prepareRow(row);
          return <Row key={i} i={i} row={row} value={leasings[i]} env={env} />;
        })}
      </tbody>
    </table>
  );
}

export default FootageTableMain;
